import { render, staticRenderFns } from "./ReferralList.vue?vue&type=template&id=7e17951a&"
import script from "./ReferralList.vue?vue&type=script&lang=ts&"
export * from "./ReferralList.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports